import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex, Stack, Text } from '@wegroup/design-system';
import RadioButton from '../../../../flows/src/components/ui/advisory-flow/components/shared-components/RadioButton';
import { useTranslation } from 'react-i18next';
import { AcknowledgementPayload } from '../../../../../types/ProductFactory';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';
import { AcknowledgementResponse } from '../../../../../types/SMT';

interface Props {
  data: AcknowledgementResponse;
  onChange: (arg0: AcknowledgementPayload) => void;
  defaultChecked?: boolean;
}

const AcknowledgementCheckbox: React.FC<React.PropsWithChildren<Props>> = ({
  data,
  defaultChecked,
  onChange,
}) => {
  const { t } = useTranslation();
  const { short, key } = data;
  const [isAccepted, setIsAccepted] = useState<boolean>();
  const handleChange = (checked: boolean) => {
    onChange({
      agreed: checked,
      key,
      text: short,
    });
    setIsAccepted(checked);
  };
  return (
    <Stack
      p={{ base: '4', laptop: '8' }}
      bg="white"
      borderRadius="6px"
      width="100%"
      border="1px"
      borderColor="gray.50"
      justify="space-between"
      spacing={{ base: '6', laptop: '4' }}
      direction={{ base: 'column', laptop: 'row' }}
      data-test-id={`ADVISORY-CONVO_OFFERS_ACKNOWLEDGEMENT_${key.toUpperCase()}`}
    >
      <Text fontSize="md">{short}</Text>
      <Flex>
        <Flex
          cursor="pointer"
          alignItems="center"
          onClick={() => handleChange(false)}
          mr="6"
          data-test-id="ADVISORY-CONVO_OFFERS_ACKNOWLEDGEMENT-CHECKBOX_NO"
        >
          <StyledRadioButton
            isSelected={defaultChecked === false || isAccepted === false}
          />
          <Text ml="2" fontSize="md">
            {t('No')}
          </Text>
        </Flex>
        <Flex
          cursor="pointer"
          alignItems="center"
          onClick={() => handleChange(true)}
          data-test-id="ADVISORY-CONVO_OFFERS_ACKNOWLEDGEMENT-CHECKBOX_YES"
        >
          <StyledRadioButton
            isSelected={defaultChecked === true || isAccepted === true}
          />
          <Text ml="2" fontSize="md">
            {t('Yes')}
          </Text>
        </Flex>
      </Flex>
    </Stack>
  );
};

const StyledRadioButton = styled(RadioButton)`
  ${mq.laptop} {
    min-width: 2.4rem;
    height: 2.4rem;
    padding: 3px;
  }
`;

export default AcknowledgementCheckbox;
